// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-profile {
  /* background-color: antiquewhite; */
  /* align-content: center; */
  box-shadow: 0 2px 1px -1px #eeeeee;
}
.rightsidedivshow {
  height: 100%;
  /* align-content: center; */
}
.profile-minimum-height {
  min-height: 55vh;
  align-content: center;
}
.profile-head-bottom {
  font-size: 10px;
}
.icon-style-profile {
  align-content: center;
  padding: 0 5px;
}
.div-btn-profile-page {
  /* padding: 2%; */
  margin-top: 2px;
  padding-left: 0;
  padding-right: 0;
  /* height: 100%; */
  /* align-content: center; */
}

.profiledivactive {
  /* background-color: #28af4b; */
  border-bottom: 2px solid #28af4b;
  border-radius: 0;
  height: 100%;
  color: #28af4b;
}

.profiledivactivehover {
  height: 100%;
  border-radius: 0;
}
.profiledivactivehover:hover {
  /* background-color: #28af4b; */
  border-bottom: 2px solid #28af4b;
  border-radius: 0;
  color: #28af4b;
}

.height-custom {
  height: 100%;
}

.innerdiv-center {
  align-content: center;
  text-align: center;
  height: 100%;
}

.card-add-height {
  height: 100%;
}

.contactus-label {
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 14px;
}

.contactus-input {
  background-color: #f5f5f5;
  border: 0.5px solid #f0f0f0;
  width: 100%;
  color: black;
  outline: none;
}
.phoneno-link {
  text-decoration: none;
  color: #333132;
}

.email-link {
  color: #333132;
}

.contactus-card {
  border: 1px solid #eeeeee;
  box-shadow: 0 1px 2px 0 #0000001e, 0 1.5px 5px 0 #0000001a;
}

.b {
  background-color: red;
}

.div-caroysel-relative-profile {
  position: relative;
}
.div-caroysel-relative-profile {
  .react-multiple-carousel__arrow--left {
    right: 45px;
    left: auto;
    top: 0;
    z-index: 0;
    border: 0.5px solid #00000010;
    background: transparent;
    min-width: 30px;
    min-height: 30px;
    border-radius: 50%;
    padding: 0;
  }
  .react-multiple-carousel__arrow--right {
    right: 10px;
    left: auto;
    top: 0;
    z-index: 0;
    border: 0.5px solid #00000010;
    background: transparent;
    min-width: 30px;
    min-height: 30px;
    border-radius: 50%;
    padding: 0;
  }

  .react-multi-carousel-list {
    position: unset;
  }
  .react-multiple-carousel__arrow::before {
    color: #333132;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profile/profile.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;IACX,UAAU;IACV,MAAM;IACN,UAAU;IACV,6BAA6B;IAC7B,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,WAAW;IACX,UAAU;IACV,MAAM;IACN,UAAU;IACV,6BAA6B;IAC7B,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":[".bg-profile {\n  /* background-color: antiquewhite; */\n  /* align-content: center; */\n  box-shadow: 0 2px 1px -1px #eeeeee;\n}\n.rightsidedivshow {\n  height: 100%;\n  /* align-content: center; */\n}\n.profile-minimum-height {\n  min-height: 55vh;\n  align-content: center;\n}\n.profile-head-bottom {\n  font-size: 10px;\n}\n.icon-style-profile {\n  align-content: center;\n  padding: 0 5px;\n}\n.div-btn-profile-page {\n  /* padding: 2%; */\n  margin-top: 2px;\n  padding-left: 0;\n  padding-right: 0;\n  /* height: 100%; */\n  /* align-content: center; */\n}\n\n.profiledivactive {\n  /* background-color: #28af4b; */\n  border-bottom: 2px solid #28af4b;\n  border-radius: 0;\n  height: 100%;\n  color: #28af4b;\n}\n\n.profiledivactivehover {\n  height: 100%;\n  border-radius: 0;\n}\n.profiledivactivehover:hover {\n  /* background-color: #28af4b; */\n  border-bottom: 2px solid #28af4b;\n  border-radius: 0;\n  color: #28af4b;\n}\n\n.height-custom {\n  height: 100%;\n}\n\n.innerdiv-center {\n  align-content: center;\n  text-align: center;\n  height: 100%;\n}\n\n.card-add-height {\n  height: 100%;\n}\n\n.contactus-label {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.contactus-input {\n  background-color: #f5f5f5;\n  border: 0.5px solid #f0f0f0;\n  width: 100%;\n  color: black;\n  outline: none;\n}\n.phoneno-link {\n  text-decoration: none;\n  color: #333132;\n}\n\n.email-link {\n  color: #333132;\n}\n\n.contactus-card {\n  border: 1px solid #eeeeee;\n  box-shadow: 0 1px 2px 0 #0000001e, 0 1.5px 5px 0 #0000001a;\n}\n\n.b {\n  background-color: red;\n}\n\n.div-caroysel-relative-profile {\n  position: relative;\n}\n.div-caroysel-relative-profile {\n  .react-multiple-carousel__arrow--left {\n    right: 45px;\n    left: auto;\n    top: 0;\n    z-index: 0;\n    border: 0.5px solid #00000010;\n    background: transparent;\n    min-width: 30px;\n    min-height: 30px;\n    border-radius: 50%;\n    padding: 0;\n  }\n  .react-multiple-carousel__arrow--right {\n    right: 10px;\n    left: auto;\n    top: 0;\n    z-index: 0;\n    border: 0.5px solid #00000010;\n    background: transparent;\n    min-width: 30px;\n    min-height: 30px;\n    border-radius: 50%;\n    padding: 0;\n  }\n\n  .react-multi-carousel-list {\n    position: unset;\n  }\n  .react-multiple-carousel__arrow::before {\n    color: #333132;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
